// IMPORTS
// Modules
import { useState, useEffect } from 'react';
// OHS
import { OHSAppHeader, OHSAppBody, OHSAppFooter } from '../../../../onehivesystems/js/OHSApp';
import OHSWidget from '../../../../onehivesystems/js/OHSWidget';
import OHSFilter from '../../../../onehivesystems/js/OHSFilter';
import OHSList, { OHSListDataFormatter } from '../../../../onehivesystems/js/OHSList';
import { OHSFormItem, OHSFormSubmit, OHSFormDataExtractor, OHSFormDataClearer } from '../../../../onehivesystems/js/OHSForm';
import OHSCRUD from '../../../../onehivesystems/js/OHSCRUD';
// Assets
import './PortTemplates.scss';
import { portTemplateModel } from './_variables';
import PortTemplate from './Modules/PortTemplate';


// COMPONENT
export default function PortTemplates (props) {
   // States and Variables
   const [portTemplates, setPortTemplates] = useState(null);
   const [fields, setFields] = useState(null);
   const [portTemplatePopups, setPortTemplatePopups] = useState({});

   // On-Load
   useEffect(function () {
      props.onehive.setOneHiveTitle("OnePort | Port Templates"); // set page title
      getFields();
   }, []);

   // Functions
   const getPortTemplates = function () {
      OHSCRUD({
         url: '/v1/oneport/porttemplates',
         method: 'GET',
         success: function (data) {
            setPortTemplates(OHSListDataFormatter(data, portTemplateModel));
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup
      });
   }
   const getFields = function () {
      OHSCRUD({
         url: '/v1/oneport/fields',
         method: 'GET',
         success: function (data) {
            // Dynamically Build Port Model
            data.forEach(function (field, i) {
               portTemplateModel[field.id] = {
                  'title': field.name,
                  'display': false
               };
            });

            // Set Fields Data
            setFields(data);

            // Get Port Templates
            getPortTemplates();
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup
      });
   }
   const addPortTemplate = function () {
      OHSCRUD({
         url: '/v1/oneport/porttemplates',
         method: 'POST',
         payload: OHSFormDataExtractor('oneport-porttemplates-add'),
         success: function (data) {
            if (portTemplates.length > 0) {
               setPortTemplates([...portTemplates, OHSListDataFormatter(data[0], portTemplateModel)]);
            } else {
               setPortTemplates([OHSListDataFormatter(data[0], portTemplateModel)]);
            }
            OHSFormDataClearer('oneport-porttemplates-add');
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true
      });
   }

   // Component
   return (
      <div className="oneport-porttemplates">
         <OHSAppHeader onehive={props.onehive} title="Port Templates" help="https://www.onehivesystems.com/documentation/oneport/porttemplates" />
         <OHSAppBody onehive={props.onehive}>
            <OHSWidget onehive={props.onehive} id='oneport-porttemplates-add' title="Add a Port Template" onEnter={addPortTemplate}>
               <OHSFormItem onehive={props.onehive} title="Name">
                  <input type='text' className='ohsinput' data-ohsformdata='name' />
               </OHSFormItem>
               <OHSFormSubmit onehive={props.onehive} add={addPortTemplate} clear={() => {OHSFormDataClearer('oneport-porttemplates-add');}} keyListener={true} />
            </OHSWidget>
            <OHSFilter onehive={props.onehive} title="Filter Port Templates" container='oneport-porttemplates-list' />
            <OHSWidget onehive={props.onehive} id='oneport-porttemplates-list' title="List of Port Templates">
               <OHSList onehive={props.onehive} content={portTemplates} popups={portTemplatePopups} setPopups={setPortTemplatePopups} template={
                  <PortTemplate onehive={props.onehive} parent={{
                     portTemplates: portTemplates,
                     setPortTemplates: setPortTemplates,
                     fields: fields,
                     setFields: setFields
                  }} />
               } />
            </OHSWidget>
         </OHSAppBody>
         <OHSAppFooter onehive={props.onehive} />
      </div>
   );
}